// src/locales/en/goodsReceivedNote.js
export const goodsReceivedNote = {
  // Page titles
  goodsReceivedNotes: 'Goods Received Notes',
  allGoodsReceivedNotes: 'All Goods Received Notes',
  createGoodsReceivedNote: 'Create Goods Received Note',
  goodsReceivedNoteDetails: 'Goods Received Note Details',
  viewAndManageAllGoodsReceivedNotes: 'View and manage all goods received notes',
  createGoodsReceivedNoteDescription: 'Record receipt of items against a purchase order',

  // List columns
  grnNumber: 'GRN #',
  purchaseOrderNumber: 'Purchase Order',
  supplier: 'Supplier',
  warehouse: 'Warehouse',
  receivedAt: 'Received At',
  receivedBy: 'Received By',
  createdAt: 'Created At',
  status: 'Status',
  actions: 'Actions',
  item: 'Item',
  details: 'GRN Details',
  itemsToReceive: 'Items to Receive',
  itemsReceived: 'Items Received',
  orderedQty: 'Ordered Quantity',
  remainingQty: 'Remaining Quantity',
  quantityReceived: 'Quantity Received',
  unitsSelected: 'units selected',

  // Status labels — used via t(`goodsReceivedNote.status_${grn.status}`)
  status_received: 'Received',
  status_cancelled: 'Cancelled',

  // Form fields
  lookupPurchaseOrder: 'Look Up Purchase Order',
  purchaseOrderIdPlaceholder: 'Enter purchase order ID or number',
  lookupButton: 'Look Up',
  warehouseLabel: 'Warehouse',
  atLeastOneItemRequired: 'Please select at least one item to receive',
  selectWarehouse: 'Select Warehouse',
  supplierDeliveryReference: 'Supplier Delivery Reference',
  supplierDeliveryReferencePlaceholder: 'Supplier\'s invoice/delivery slip number (optional)',
  notes: 'Notes',
  notesPlaceholder: 'Add any notes about this receipt...',

  // Actions
  create: 'Create Goods Received Note',
  save: 'Save',
  cancelGoodsReceivedNote: 'Cancel Goods Received Note',
  print: 'Print',
  printGoodsReceivedNote: 'Print Goods Received Note',
  backToGoodsReceivedNotes: 'Back to Goods Received Notes',

  // Confirmations
  confirmCancel: 'Are you sure you want to cancel this goods received note? Stock and the purchase order\'s received quantity will be reversed.',
  cancellationReason: 'Reason for Cancellation',
  cancellationReasonPlaceholder: 'Enter reason for cancellation...',

  // Filters
  filterByWarehouse: 'Filter by Warehouse',
  filterByPurchaseOrder: 'Filter by Purchase Order',
  dateFrom: 'From',
  dateTo: 'To',
  allWarehouses: 'All Warehouses',

  // Success / error messages
  goodsReceivedNoteCreatedSuccess: 'Goods received note {number} created successfully',
  goodsReceivedNoteCancelledSuccessfully: 'Goods received note cancelled successfully',
  failedToCreateGoodsReceivedNote: 'Failed to create goods received note',
  failedToLoadGoodsReceivedNotes: 'Failed to load goods received notes',
  failedToLoadGoodsReceivedNote: 'Failed to load goods received note',
  failedToCancelGoodsReceivedNote: 'Failed to cancel goods received note',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  purchaseOrderRequired: 'Please look up a purchase order',
  warehouseRequired: 'Please select a warehouse',
  purchaseOrderNotFound: 'Purchase order not found',
  purchaseOrderCancelled: 'Cannot receive goods against a cancelled purchase order',

  // Empty states
  noGoodsReceivedNotesFound: 'No goods received notes found',
  noGoodsReceivedNotesYet: 'No goods received notes yet.',
  noGoodsReceivedNotesFoundDescription: 'No goods received notes match your current filters',
  noGoodsReceivedNotesYetDescription: 'Create your first goods received note to record a delivery from a supplier.',
  createFirstGoodsReceivedNote: 'Create First Goods Received Note',

  na: 'N/A',

  // Searchable purchase order lookup
  searchPurchaseOrder: "Search by purchase order number or ID...",
  noOpenPurchaseOrders: "No open purchase orders found",
};
